module.exports = __webpack_public_path__ + "static/geo-gate-map-58286dbbfd13751b67b85c2920089d7d.png";